import * as React from 'react';
import {useDispatch} from 'react-redux';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {UnlockIcon} from 'shells/icon/svg/unlock-icon';

import {useGetUnlockInfo} from '../../../people-iq/graphql/hooks/use-get-unlock-info';

import * as actions from '../companies-list/companies-actions';
import {UnlockPopover} from '../unlock-companies/unlock-popover';

import {useShowUnlockConfirmation} from './unlock-hooks/use-show-unlock-confirmation';
import {useUnlockCompanies} from './unlock-hooks/use-unlock-companies';

type Props = {
    selectedCompanyIds: string[];
    afterUnlock?: () => any;
    isButtonBig?: boolean;
    isFullWidth?: boolean;
};

export function UnlockCompaniesButton(props: Props) {
    const [shouldShowPopover, setShouldShowPopover] = React.useState<boolean>(false);
    const [isHideChecked, setIsHideChecked] = React.useState<boolean>(false);
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const dispatch = useDispatch();

    const {unlockConfirmation} = useShowUnlockConfirmation();
    const {unlockInfo} = useGetUnlockInfo();
    const unlockCompanies = useUnlockCompanies();

    const unlockButtonRef = React.useRef();

    const afterUnlock = props.afterUnlock ? props.afterUnlock : undefined;

    const onUnlockCompanies = () => {
        setIsSaving(true);
        unlockCompanies({mcfxCompanyIds: props.selectedCompanyIds}).then((response) => {
            if (isHideChecked && unlockConfirmation) {
                // Action causes entire page to reload
                return unlockConfirmation.onHideUnlockConfirmation();
            }

            const updatedCompanies =
                response &&
                response.data &&
                response.data.mcfxCompaniesUnlock &&
                response.data.mcfxCompaniesUnlock.mcfxCompanies;

            if (updatedCompanies) {
                dispatch(actions.updateMcfxCompaniesListItems({updatedCompanies}));
            }

            if (afterUnlock) {
                setIsSaving(false);
                setShouldShowPopover(false);

                afterUnlock();
            }
        });
    };

    return (
        <>
            <Button
                getButtonRef={unlockButtonRef}
                variant='primary'
                size={props.isButtonBig ? 'big' : 'normal'}
                isFullWidth={props.isFullWidth}
                disabled={props.selectedCompanyIds.length === 0}
                icon={UnlockIcon}
                onClick={
                    (unlockConfirmation && unlockConfirmation.shouldShow) || !unlockConfirmation
                        ? () => {
                              setShouldShowPopover(true);
                          }
                        : onUnlockCompanies
                }
            >
                Unlock
            </Button>
            {unlockButtonRef.current && unlockInfo && shouldShowPopover ? (
                <UnlockPopover
                    selectedItemCount={props.selectedCompanyIds.length}
                    unlockLimit={unlockInfo.unlockLimit}
                    unlockedThisMonth={unlockInfo.unlockedThisMonth}
                    onUnlock={onUnlockCompanies}
                    onClose={() => setShouldShowPopover(false)}
                    anchor={unlockButtonRef.current}
                    isSaving={isSaving}
                    dontAskAgain={isHideChecked}
                    setDontAskAgain={setIsHideChecked}
                />
            ) : undefined}
        </>
    );
}
